import React from 'react';
import { useSelector } from 'react-redux';
import { Badge } from 'react-bootstrap';
import {
  selectActiveChecklistType,
  selectPrimaryChecklistCompletionStats,
  selectSecondaryChecklistCompletionStats, selectSubscriptionChecklistLoading,
} from '../../redux/slices/subscriptionChecklistSlice/subscriptionChecklistSlice';
import { SubscriptionChecklistType } from '../../utility/types/SubscriptionChecklistType';

const CHECKLIST_TYPE_BADGE_COLORS = {
  [SubscriptionChecklistType.PRIMARY_CHECKLIST]: '#EE3524',
  [SubscriptionChecklistType.SECONDARY_CHECKLIST]: '#468AC9',
};

function ChecklistCompletionBadge() {
  const isLoading = useSelector(selectSubscriptionChecklistLoading);
  const activeChecklistType = useSelector(selectActiveChecklistType);
  const primaryChecklistStats = useSelector(selectPrimaryChecklistCompletionStats);
  const secondaryChecklistStats = useSelector(selectSecondaryChecklistCompletionStats);

  if (isLoading || !activeChecklistType) {
    return null;
  }

  const activeChecklistStats = activeChecklistType === SubscriptionChecklistType.PRIMARY_CHECKLIST
    ? primaryChecklistStats
    : secondaryChecklistStats;

  const incompleteItemCount = Math.max(
    (activeChecklistStats.totalItems || 0) - (activeChecklistStats.completedItems || 0),
    0,
  );

  if (incompleteItemCount === 0) {
    return null;
  }

  return (
    <Badge
      pill
      className="checklist-completion-badge text-white font-weight-bold"
      style={{
        backgroundColor: CHECKLIST_TYPE_BADGE_COLORS[activeChecklistType],
        padding: '3px 7px',
        fontSize: '12px',
      }}
      aria-label={`${incompleteItemCount} incomplete setup checklist items`}
    >
      {incompleteItemCount}
    </Badge>
  );
}

export default ChecklistCompletionBadge;
